export default __webpack_public_path__ + "static/media/Brooster-Rooster.3853260e.png";